module.exports = __webpack_public_path__ + "static/media/dealer_b_640.74cbe9ff.png";